<template>
  <VaCard v-if="apiConnectionState.unavailable" stripe stripe-color="warning" class="api-connection-notice" role="alert">
    <VaCardContent>
      <h2>{{ apiConnectionState.reason === 'server' ? 'Данные сервера временно недоступны' : 'Нет связи с сервером' }}</h2>
      <p>Не удалось получить данные. Проверьте соединение или повторите попытку немного позже.</p>
      <p v-if="apiConnectionState.preserveForm" class="form-hint">Открытая форма остаётся на месте. Не обновляйте страницу, чтобы не потерять введённые данные.</p>
      <VaButton :loading="apiConnectionState.checking" :disabled="apiConnectionState.checking" @click="retryApiConnection">
        {{ apiConnectionState.pendingReads ? 'Повторить загрузку' : 'Проверить соединение' }}
      </VaButton>
    </VaCardContent>
  </VaCard>
</template>

<script setup>
import { watch } from 'vue'
import { useToast } from 'vuestic-ui'
import { apiConnectionState } from '../services/apiConnection'
import { retryApiConnection } from '../services/setupInterceptors'

const { init } = useToast()
watch(() => apiConnectionState.recoveryCount, () => {
  init({ message: 'Связь с сервером восстановлена', color: 'success', position: 'bottom-right' })
})
</script>

<style scoped>
.api-connection-notice { margin: 0 0 16px; }
h2 { margin: 0 0 12px; font-size: 24px; line-height: 1.3; }
p { margin: 0 0 16px; line-height: 1.5; color: #647086; }
.form-hint { padding: 12px 16px; background: #f5f6fd; border-left: 3px solid #8574db; }
</style>
